import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VERIFICATION_ROUTES } from './verification.routes';

@NgModule({
  imports: [RouterModule.forChild(VERIFICATION_ROUTES)],
  exports: [RouterModule]
})
export class VerificationRoutingModule { }
